import type { RoutesMap } from '@xing-com/crate-xinglet';

import { App } from './app';
import { FollowedCompaniesRoute } from './pages/followed-companies-route';
import { IndustriesList } from './pages/industries';
import { IndustryDetail } from './pages/industry-detail';
import { Landing } from './pages/landing';
import { ManagedCompaniesRoute } from './pages/managed-companies-route';
import { MostVisitedCompaniesRoute } from './pages/most-visited-companies-route';
import { RecentlyClaimedCompaniesRoute } from './pages/recently-claimed-companies-route';

export const routes: RoutesMap = {
  '/companies/@companies': App,
  '@companies/': Landing,
  '@companies/industries': IndustriesList,
  '@companies/industries/:industry': IndustryDetail,
  '@companies/industries/:industry/:segment': IndustryDetail,
  '@companies/my_companies_follow': FollowedCompaniesRoute,
  '@companies/my_companies_edit': ManagedCompaniesRoute,
  '@companies/most_visited': MostVisitedCompaniesRoute,
  '@companies/subscriptions': RecentlyClaimedCompaniesRoute,
};
